import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import DatepickerDefault from "../../components/datepicker";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";
import { DropDownInput } from "../../wrappers/selectInput";
import * as Yup from "yup";
import { getMilliSecUTC } from "../../utils/EllowUtils";
import { Error } from "@progress/kendo-react-labels";

export type ContractDetailsFormFields = {
  closedBy: any;
  candidateAppliedBy: any;
  salaryOffered: any;
  currencyType: any;
  noticePeriod: any;
  dateOfJoining: any
};

interface props {
  onClose?: any;
  ClickHandler?: any;
  allocatedTo?: any;
  defaultvalues?:any;
  projectData?: any;
  jobMetadata?: any;
  contractEndDate?: any;
  addProject?: any;
  projectList?: any;
  submitAddProject?: any;
  buttonName?: string;
  closed?: any;
  terminateComment?: any;
  disableButton?: any;
  getProjectDetailsById?: any;
  allRecruiters?: any;
  createdBy?: any;
}

const validationSchema = Yup.object({
  salaryOffered: Yup.string().required("Field is required").nullable(),
  closedBy: Yup.string().required("Field is required").nullable(),
  candidateAppliedBy: Yup.string().required("Field is required").nullable(),
  noticePeriod: Yup.string().required("Field is required").nullable(),
});

const FulltimeDetails: React.FC<props> = ({
  onClose,
  ClickHandler,
  allocatedTo,
  defaultvalues,
  buttonName,
  allRecruiters,
  createdBy
}) => {

  const formOptions = {
    resolver: yupResolver(validationSchema)
  }

  const { register, handleSubmit, control, setValue, formState } = useForm<ContractDetailsFormFields>(formOptions);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errors, setErrors] = useState<{ dateOfJoining?: string }>({ dateOfJoining: ""});

  useEffect(() => {  
      
    if(defaultvalues){
      setValue('closedBy',  defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.closedBy)
      setValue('candidateAppliedBy',  defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.candidateAppliedBy)
      setValue('salaryOffered', defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.salaryOffered)
      setValue('currencyType', defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.currencyType)
      setValue('noticePeriod', defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.noticePeriod)
      setValue('dateOfJoining', defaultvalues[0].contractMetadata && new Date(defaultvalues[0].contractMetadata.dateOfJoining))
    }else{
      if(createdBy){
        setValue('candidateAppliedBy',createdBy)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultvalues])


  const onSubmit = (data: any) => {
    if (!data.dateOfJoining) {
      errors.dateOfJoining = 'Field is required'
    }else{
      data.noticePeriod = parseInt(data.noticePeriod)
      data.salaryOffered = parseInt(data.salaryOffered)
      data.updatedOn = getMilliSecUTC(new Date())
      data.dateOfJoining = getMilliSecUTC(data.dateOfJoining)
      if(!defaultvalues){
        data.createdOn = getMilliSecUTC(new Date())
      }else{
        data.createdOn = defaultvalues[0].contractMetadata.dateOfJoining
      }     
      ClickHandler(data)
    }
    
  }
  
    const handleChange = (e: any, name: string) => {
      setValue("dateOfJoining", getMilliSecUTC(e.target.value))
    }

  return (
    <>
    <Modal title={"Contract Details "} size="medium" onClose={onClose}>
    <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="closedBy"
              data={allocatedTo}
              label="Position Closed By*"
              register={register}
              errors={formState.errors}
              control={control}
              defaultValue={defaultvalues && defaultvalues.closedBy}
            />
          </div>
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="candidateAppliedBy"
              data={allRecruiters}
              label="Candidate applied by*"
              register={register}
              errors={formState.errors}
              control={control}
              defaultValue={defaultvalues && defaultvalues.candidateAppliedBy}
            />
          </div>
        </div>
        <div className="half-form-wrap">
        <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="salaryOffered"
              label="Salary offered*"
              type="number"
              register={register}
            //   value={salaryOffered}
              errors={formState.errors}
              placeholder="Resource cost"
              // onchange={(e: any) => handleChange(e, "salaryOffered")}
            />
          </div>
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="currencyType"
              data={["INR", "USD"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Currency Type*"
              defaultValue={defaultvalues && defaultvalues.currencyType}
            />
          </div>
        </div>
        <div className="half-form-wrap">
        <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="noticePeriod"
              register={register}
              errors={formState.errors}
              label="Notice Period(Weeks)*"
              placeholder="Enter notice period"
            />
          </div>
          <div className="form-group">
            <label className="lablel">Date of joining</label>
            <DatepickerDefault
              onChange={(e: any) => handleChange(e, "dateOfJoining")}
              defaultValue={defaultvalues && defaultvalues[0] && defaultvalues[0].contractMetadata.dateOfJoining && new Date(defaultvalues[0].contractMetadata.dateOfJoining)}
            />
            <Error>{errors?.dateOfJoining}</Error>
          </div>
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          {  <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            {buttonName}
          </Button>}
        </div>
    </Modal>
    </>
  );
};

export default FulltimeDetails;
